import { createAction, props } from '@ngrx/store';
import { PatientProblem } from '../../../models/patient-problem';

export const getPatientProblems = createAction('[Patient Problem] Get Patient Problems');

export const getPatientProblemsSuccess = createAction(
  '[Patient Problem] Get Patient Problems Success',
  props<{
    patientProblems: PatientProblem[];
    pageNumber: number;
    isAtEndOfData: boolean;
    totalRecordCount: number;
  }>()
);

export const getPatientProblemsFailure = createAction(
  '[Patient Problem] Get Patient Problems Failure',
  props<{ error: unknown }>()
);

export const setPageNumber = createAction('[Patient Problem] Set Page Number', props<{ pageNumber: number }>());

export const getAllPatientProblems = createAction(
  '[Patient Problem] Get All Patient Problems',
  props<{ patientId: number }>()
);

export const getAllPatientProblemsSuccess = createAction(
  '[Patient Problem] Get All Patient Problems Success',
  props<{ patientProblems: PatientProblem[]; patientId: number; loadedAt: number }>()
);

export const getAllPatientProblemsFailure = createAction(
  '[Patient Problem] Get All Patient Problems Failure',
  props<{ error: unknown }>()
);

export const invalidateProblemCache = createAction('[Patient Problem] Invalidate Problem Cache');

export const recordPatientProblemPrintEvent = createAction(
  '[Patient Problem] Record Print Event',
  props<{ patientId: number; patientProblemIds: number[] }>()
);

export const recordPatientProblemPrintEventSuccess = createAction('[Patient Problem] Record Print Event Success');

export const recordPatientProblemPrintEventFailure = createAction(
  '[Patient Problem] Record Print Event Failure',
  props<{ error: unknown }>()
);
